(() => {
  const FAVORITES_KEY = 'kk_favorites';

  const readFavorites = () => {
    try {
      return JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
    } catch (_) {
      return [];
    }
  };

  const writeFavorites = (items) => {
    try {
      localStorage.setItem(FAVORITES_KEY, JSON.stringify(items));
    } catch (_) {}
  };

  const initFavorites = (root) => {
    root.querySelectorAll('[data-kk-favorite]').forEach((button) => {
      if (button.dataset.kkFavoriteReady === 'true') return;
      button.dataset.kkFavoriteReady = 'true';

      const handle = button.dataset.productHandle;
      const tooltip = button.querySelector('.kk-favorite-tooltip');
      const label = button.querySelector('.kk-favorite-label');

      const render = () => {
        const active = readFavorites().some((item) => item.handle === handle);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? 'Odstrani iz priljubljenih' : 'Dodaj med priljubljene');
        if (tooltip) tooltip.textContent = active ? 'Odstrani iz priljubljenih' : 'Dodaj med priljubljene';
        if (label) label.textContent = active ? 'Odstrani' : 'Priljubljeno';
      };

      button.addEventListener('click', () => {
        const favorites = readFavorites();
        const index = favorites.findIndex((item) => item.handle === handle);
        if (index >= 0) {
          favorites.splice(index, 1);
        } else {
          favorites.push({
            handle,
            title: button.dataset.productTitle,
            url: button.dataset.productUrl,
            image: button.dataset.productImage,
          });
        }
        writeFavorites(favorites);
        render();
      });

      render();
    });
  };

  const initLightbox = (root) => {
    const lightbox = root.querySelector('[data-kk-lightbox]');
    if (!lightbox || lightbox.dataset.kkLightboxReady === 'true') return;
    lightbox.dataset.kkLightboxReady = 'true';

    const image = lightbox.querySelector('[data-kk-lightbox-image]');
    const closeButtons = lightbox.querySelectorAll('[data-kk-lightbox-close]');
    const previousButton = lightbox.querySelector('[data-kk-lightbox-previous]');
    const nextButton = lightbox.querySelector('[data-kk-lightbox-next]');
    const mediaImages = Array.from(root.querySelectorAll('.product__media-list .product__media-item .product__media img'));
    let previousFocus = null;
    let currentIndex = 0;

    const updateNavigation = () => {
      const hasMultipleImages = mediaImages.length > 1;
      if (previousButton) previousButton.hidden = !hasMultipleImages;
      if (nextButton) nextButton.hidden = !hasMultipleImages;
    };

    const showImage = (index) => {
      if (!mediaImages.length) return;
      currentIndex = (index + mediaImages.length) % mediaImages.length;
      const sourceImage = mediaImages[currentIndex];
      image.src = sourceImage.currentSrc || sourceImage.src;
      image.alt = sourceImage.alt || '';
    };

    const close = () => {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('kk-lightbox-open');
      image.removeAttribute('src');
      if (previousFocus) previousFocus.focus();
    };

    const open = (sourceImage, trigger) => {
      if (!sourceImage) return;
      previousFocus = trigger;
      const matchedIndex = mediaImages.indexOf(sourceImage);
      currentIndex = matchedIndex >= 0 ? matchedIndex : 0;
      showImage(currentIndex);
      updateNavigation();
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('kk-lightbox-open');
      lightbox.querySelector('.kk-image-lightbox__close')?.focus();
    };

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('.product__media-toggle, .product__modal-opener');
      if (!trigger || trigger.closest('.thumbnail-slider')) return;
      const mediaItem = trigger.closest('.product__media-item');
      const sourceImage = mediaItem?.querySelector('.product__media img');
      if (!sourceImage) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      open(sourceImage, trigger);
    }, true);

    previousButton?.addEventListener('click', () => showImage(currentIndex - 1));
    nextButton?.addEventListener('click', () => showImage(currentIndex + 1));
    closeButtons.forEach((button) => button.addEventListener('click', close));

    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft' && mediaImages.length > 1) showImage(currentIndex - 1);
      if (event.key === 'ArrowRight' && mediaImages.length > 1) showImage(currentIndex + 1);
    });
  };

  const init = () => {
    document.querySelectorAll('.kk-main-product').forEach((root) => {
      initFavorites(root);
      initLightbox(root);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
